import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import TableToolbar from 'components/table/TableToolbar';
import SearchInput from 'components/search/SearchInput';
import MainTable from 'components/table/MainTable';
import DefaultButton from 'components/button/DefaultButton';
import { useTranslation } from 'react-i18next';
import { IProject } from '../../../utils/types/storyTypes';
import CouponRegisterModal from './CouponRegisterModal';
import { Trash } from 'iconsax-react';
import DeleteModal from '../../../components/modal/DeleteModal';
import { ICoupon, INotice } from '../../../utils/types/operationTypes';
import { couponApis } from '../../../apis/operation/couponApis';
import TextButton from '../../../components/button/TextButton';

/**
 * * 판매 - 인앱 상점 관리 - 목록
 */

interface IProps {
  selectProject: IProject;
}

const CouponListPage = ({ selectProject }: IProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchData, setSearchData] = useState();
  const [coupons, setCoupons] = useState<ICoupon[]>([]);
  const [visible, setVisible] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState<ICoupon>();

  const handleLink = (coupon: ICoupon) => (e) => {
    navigate(`/coupon/${coupon.id}`, {
      state: { coupon: coupon, selectProject: selectProject },
    });
  };

  const handleClickDeleteModal = (product: ICoupon) => {
    setSelectedCoupon(product);
    setDeleteModalOpen(true);
  };

  const fetchData = async () => {
    const res = await couponApis.getCouponList(selectProject.project_id);
    setCoupons(res.coupons);
  };

  const columnOrigin = [
    {
      title: 'id',
      align: 'center',
      width: '6rem',
      dataIndex: 'id',
      sorter: (a, b) => a.master_id - b.master_id,
    },
    {
      title: '쿠폰타입',
      dataIndex: 'coupon_type',
      width: '2rem',
    },
    {
      title: '쿠폰명',
      dataIndex: 'coupon_name',
      width: '8rem',
      align: 'center',
      render: (text, record: ICoupon) => (
        <TextButton onClick={handleLink(record)}>{text}</TextButton>
      ),
    },
    {
      title: t('ifYou.table.action'),
      width: '10rem',
      align: 'center',
      render: (_, record: ICoupon) => {
        return (
          <div>
            <Trash
              size='24'
              onClick={() => {
                handleClickDeleteModal(record);
              }}
            />
          </div>
        );
      },
    },
  ];

  const handleDelete = async () => {
    setLoading(true);
    await couponApis.deleteCoupon(selectedCoupon!);
    fetchData();
    setDeleteModalOpen(false);
    setLoading(false);
  };

  useEffect(() => {
    fetchData().catch(console.log);
  }, [selectProject]);

  return (
    <>
      <TableToolbar>
        <SearchInput
          setSearchData={setSearchData}
          placeholder={t('ifYou.header.inputPlaceHolder')}
        />
        <div>
          <DefaultButton
            name='register'
            onClick={() => setVisible(true)}
            disabled={false}
          >
            {'쿠폰 생성'}
          </DefaultButton>
        </div>
      </TableToolbar>

      <MainTable columns={columnOrigin} dataSource={coupons} />

      <CouponRegisterModal
        visible={visible}
        setVisible={setVisible}
        fetchData={fetchData}
      />

      <DeleteModal
        visible={deleteModalOpen}
        setVisible={setDeleteModalOpen}
        title={'인앱상품 삭제'}
        content={''}
        label={selectedCoupon?.coupon_name}
        handleDelete={handleDelete}
        loading={loading}
      />
    </>
  );
};

export default CouponListPage;
